module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/symbol-googleplay_8fd300e.png";